import { AuthHandlerContext } from "helpers/context/Authentication/AuthenticationContext";
import React from "react";

export default function useAuthHandler() {

    return React.useContext(AuthHandlerContext)!;

};
